<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">{{ eService?.id ? "Modifica" : "Nuovo" }} SERVIZIO VALET</a>
      </label>
    </div>

    <section class="content-padding darker">
      <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="expertServiceForm" (ngSubmit)="onSubmit()">

          <div class="delivery-colle-data-box">
            <fieldset>
              <legend>SERVIZO DI VALET:</legend>

              <div class="col-50 grid-element">
                <label for="name">Nome Servizio*</label>
                <input type="text" name="name" formControlName="serviceName">
                <app-error-html-handler [ctrl]="expertServiceForm.get('serviceName')" [messages]="formValidationMsgs.serviceName"></app-error-html-handler>
              </div>

              <div class="col-50 grid-element">
                <label for="name">Tipo Servizio*</label>
                <select name="" id="" formControlName="serviceType">
                  <option disabled selected="true"></option>
                  <option value="fixedpricesalary">Servizi a Prezzo Fisso</option>
                  <option value="hourlyratesalary">Servizi in Ora</option>
                  <option value="warehousesalary">Servizi Magazzino</option>
                </select>
                <app-error-html-handler [ctrl]="expertServiceForm.get('serviceType')" [messages]="formValidationMsgs.serviceType"></app-error-html-handler>
              </div>
              
              <div class="col-50 grid-element">
                  <label for="sku">Note</label>
                  <textarea formControlName="notes" rows="5" placeholder="Scrivi una descrizione"></textarea>
              </div>
        
              <div class="center" style="margin-top: 10px;">
                <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!expertServiceForm.valid">
                  Salva<i class="ml-10 far fa-save"></i>
                </button>
              </div>
            </fieldset>
          </div>
        </form>
      </div>
    </section>
  </div>
</section>

<!--
<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">{{eService?.id ? "Modifica" : "Nuovo"}} Valet Servizio</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
      </span>
    </div>
  </div>
</section>

<section class="content-padding darker">
    <div class="narrow-wrapper">
      <form class="has-cols" [formGroup]="expertServiceForm" (ngSubmit)="onSubmit()">
        <div class="col-50 grid-element">
          <label for="name">Nome Servizio*</label>
          <input type="text" name="name" formControlName="serviceName">
          <app-error-html-handler [ctrl]="expertServiceForm.get('serviceName')" [messages]="formValidationMsgs.serviceName"></app-error-html-handler>
        </div>

        <div class="col-50 grid-element">
          <label for="name">Tipo Servizio*</label>
          <select name="" id="" formControlName="serviceType">
            <option disabled selected="true"></option>
            <option value="fixedpricesalary">Servizi a Prezzo Fisso</option>
            <option value="hourlyratesalary">Servizi in Ora</option>
            <option value="warehousesalary">Servizi Magazzino</option>
          </select>
          <app-error-html-handler [ctrl]="expertServiceForm.get('serviceType')" [messages]="formValidationMsgs.serviceType"></app-error-html-handler>
        </div>
        
        <div class="col-50 grid-element">
            <label for="sku">Note</label>
            <textarea formControlName="notes" rows="5" placeholder="Scrivi una descrizione"></textarea>
        </div>
  
        <div class="center" style="margin-top: 10px;">
          <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!expertServiceForm.valid">
            Salva<i class="ml-10 far fa-save"></i>
          </button>
        </div>
      </form>
      <br class="clear">
    </div>
  </section>
-->